import renderParagraph from './renderParagraph';

const checkRoute = (path, actualPath, text, color) => {
  if (path === actualPath) {
    return renderParagraph(text, color);
  }
  return renderParagraph(text);
};

export default checkRoute;
